import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import messages from './messages';
import { type SwitcherItemType } from './links';

export default (startUrl: string): SwitcherItemType => ({
	key: 'atlassian-start',
	iconKey: 'atlassian',
	label: <FormattedMessage {...messages.atlassianStart} />,
	href: startUrl,
});
